import React from 'react'

const Comb = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    width="512"
    height="512"
    {...props}
  >
    <g id="outline">
      <path d="M64.871,319.213C59.4,344.927,56,375.883,56,400c0,24.415,3.5,47.484,9.854,64.959C75.184,490.615,87.4,496,96,496s20.816-5.385,30.146-31.041C132.5,447.484,136,424.415,136,400c0-24.117-3.4-55.073-8.871-80.787a80.018,80.018,0,0,1,11.789-61.31C160.058,226.017,176,170.17,176,128c0-29.391-7.994-57.125-22.511-78.093-7.251-10.474-15.76-18.738-25.293-24.561a60.129,60.129,0,0,0-64.392,0c-9.533,5.823-18.042,14.087-25.293,24.561C23.994,70.875,16,98.609,16,128c0,42.17,15.942,98.017,37.082,129.9A80.018,80.018,0,0,1,64.871,319.213Zm46.238,140.279C105.957,473.659,99.809,480,96,480s-9.957-6.341-15.109-20.508C75.157,443.725,72,422.6,72,400c0-21.274,2.779-48.15,7.331-71.57A87.546,87.546,0,0,0,95.76,302.142l.24-.6.24.6a87.554,87.554,0,0,0,16.429,26.287C117.221,351.85,120,378.726,120,400,120,422.6,116.843,443.725,111.109,459.492ZM51.666,59.015C63.727,41.594,79.471,32,96,32s32.273,9.594,44.334,27.015C153.016,77.333,160,101.832,160,128c0,38.775-15.118,91.952-34.418,121.062a96.589,96.589,0,0,0-15.764,43.944l-6.39-15.977a8,8,0,0,0-14.856,0l-6.39,15.977a96.612,96.612,0,0,0-15.764-43.944C47.118,219.952,32,166.775,32,128,32,101.832,38.984,77.333,51.666,59.015Z" />
      <circle cx="96" cy="216" r="8" />
      <circle cx="96" cy="168" r="8" />
      <circle cx="96" cy="144" r="8" />
      <circle cx="96" cy="120" r="8" />
      <circle cx="96" cy="96" r="8" />
      <circle cx="96" cy="48" r="8" />
      <circle cx="72" cy="56" r="8" />
      <circle cx="120" cy="56" r="8" />
      <circle cx="56" cy="80" r="8" />
      <circle cx="136" cy="80" r="8" />
      <circle cx="48" cy="104" r="8" />
      <circle cx="48" cy="128" r="8" />
      <circle cx="48" cy="152" r="8" />
      <circle cx="144" cy="104" r="8" />
      <circle cx="144" cy="128" r="8" />
      <circle cx="136" cy="176" r="8" />
      <circle cx="56" cy="176" r="8" />
      <circle cx="128" cy="200" r="8" />
      <circle cx="96" cy="192" r="8" />
      <circle cx="96" cy="72" r="8" />
      <circle cx="120" cy="224" r="8" />
      <circle cx="96" cy="240" r="8" />
      <circle cx="144" cy="152" r="8" />
      <circle cx="64" cy="200" r="8" />
      <circle cx="72" cy="224" r="8" />
      <circle cx="72" cy="96" r="8" />
      <circle cx="72" cy="128" r="8" />
      <circle cx="72" cy="160" r="8" />
      <circle cx="120" cy="96" r="8" />
      <circle cx="120" cy="128" r="8" />
      <circle cx="120" cy="160" r="8" />
      <path d="M488,152a8,8,0,0,0,8-8V128a8,8,0,0,0-4.422-7.155L447.355,98.733A178.352,178.352,0,0,0,368,80c-97.047,0-176,78.953-176,176s78.953,176,176,176a178.352,178.352,0,0,0,79.355-18.733l44.223-22.112A8,8,0,0,0,496,384V368a8,8,0,0,0-8-8H352V344H488a8,8,0,0,0,0-16H352V312H488a8,8,0,0,0,0-16H352V280H488a8,8,0,0,0,0-16H352V248H488a8,8,0,0,0,0-16H352V216H488a8,8,0,0,0,0-16H352V184H488a8,8,0,0,0,0-16H352V152ZM208,256c0-70.356,45.647-130.25,108.88-151.626l-25.969,25.969a64.571,64.571,0,0,0,0,91.314,48.567,48.567,0,0,1,0,68.686,64.571,64.571,0,0,0,0,91.314l25.969,25.969C253.647,386.25,208,326.356,208,256ZM480,376v3.056l-39.8,19.9a161.161,161.161,0,0,1-93.777,15.584l-44.2-44.2a48.567,48.567,0,0,1,0-68.686,64.571,64.571,0,0,0,0-91.314,48.567,48.567,0,0,1,0-68.686l44.2-44.2A161.161,161.161,0,0,1,440.2,113.044l39.8,19.9V136H344a8,8,0,0,0-8,8V368a8,8,0,0,0,8,8Z" />
    </g>
  </svg>
)

export default Comb
